import React, { useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import InputGroup from "react-bootstrap/InputGroup";

// Imports (door Tom)
import FormControl from "react-bootstrap/FormControl";
import Form from "react-bootstrap/Form";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import CardGroup from "react-bootstrap/CardDeck";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Alert from "react-bootstrap/Alert";

import { FaCheck } from "react-icons/fa";

import PageControl from "../components/PageControl";
import { formatURL, formatLines } from "../utils/utils";

import { CustomerNameTooltip, CustomerEmailTooltip, CustomerBTWTooltip, CustomerStreetTooltip, CustomerNumberTooltip, CustomerZipTooltip, CustomerCityTooltip } from "../components/tooltips/CustomerTooltips"
import DesignStepToolTip from "./tooltips/DesignStepToolTip";
import { OverlayTrigger, Popover } from "react-bootstrap";


function SidePanel(props) {

  const [showOrderPopup, setShowOrderPopUp] = useState(false);
  const [hideInvoiceAddress, setHideInvoiceAddress] = useState(true);
  const [orderErrors, setOrderErrors] = useState({});
  const [inputBoxDimensions, setInputBoxDimensions] = useState(props.boxDimensions);
  const [pageControlAllowNext, setPageControlAllowNext] = useState(true);
  const [showErrors, setShowErrors] = useState(false);
  let panelContent;
  let panelTitle;
  let pageControl = <PageControl page={props.designstep} prevPage={props.prevPage} nextPage={props.nextPage} handleOrderPopup={handleOrderPopup} allowNext={pageControlAllowNext} />;
  let bestellenKnop = true;

  const filteredModules = filterModules(props.modules);


  function filterModules(modules) {
    const filteredModules = {
      single: {
        open: [],
        doorLeft: [],
        doorRight: []
      },
      double: {
        open: [],
        doors: []
      },
    }

    modules.single.forEach(module => {

      // Single Module
      String(module.module_kps_name).split('_').forEach(section => {
        if (section.includes("D") || section.includes("open")) {
          switch (section) {
            case "open": filteredModules.single.open.push(module); break;
            case "D1L": filteredModules.single.doorLeft.push(module); break;
            case "D1R": filteredModules.single.doorRight.push(module); break;
            default:
              console.log("Unable to filter module: " + module.module_kps_name);
          }
        }
      });
    });
    modules.double.forEach(module => {
      // Double Module
      String(module.module_kps_name).split('_').forEach(section => {
        if (section.includes("D") || section.includes("open")) {
          switch (section) {
            case "open": filteredModules.double.open.push(module); break;
            case "D2": filteredModules.double.doors.push(module); break;
            default:
              console.log("Unable to filter module: " + module.module_kps_name);
          }
        }
      })
    });

    return filteredModules;
  }

  console.log(props.materials);

  function setMaterial(data, side) {
    if (side === "in") props.setInnerMaterial(data)
    else props.setOuterMaterial(data)
    
    // props.updatePrice()
  }

  function handleErrors(show) {
    setShowErrors(show)
  }

  function changeBestellen() {
    let nErrors = Object.keys(props.formErrors).length;
    console.log("errors: " + nErrors);
    let element = document.getElementById("mylabel");
    console.log("element: " + element);
    if(element !== null) {
      let hidden = element.getAttribute("hidden");
      if(nErrors === 0) {
        element.removeAttribute("hidden");
        bestellenKnop = true;
        document.getElementById("btnOrder").disabled = true;
        document.getElementById("algv_checkbox").disabled = true;
      }
    }
  }

  function handleOrderPopup(show) {
    let errors = {};
    props.generateOrderJSON(errors);
    if (Object.keys(errors).length > 0) {
      setOrderErrors(errors);
      setShowErrors(true);
      return;
    }

    if (!show) {
      props.clearCustomerFormErrors();
    }

    setShowOrderPopUp(show)
    setHideInvoiceAddress(!show ? true : hideInvoiceAddress)
  }

  function toggleHideInvoiceAddress() {
    setHideInvoiceAddress(!hideInvoiceAddress)
  }

  function toggleButtonOrder() {
    if(document.getElementById("algv_checkbox").checked) {
			document.getElementById("btnOrder").disabled = false;
    }
    else {
			document.getElementById("btnOrder").disabled = true;
    }
  }

  function _hasNoSingleModules() {
    const modules = props.slots

    for (let i = 0; i < modules.length; i++) {
      if (modules[i]?.moduleData != null && modules[i]?.moduleData?.module_size === 1)
        return false;
    }

    return true;
  }

  function _hasNoDoubleModules() {
    const modules = props.slots

    for (let i = 0; i < modules.length; i++) {
      if (modules[i]?.moduleData != null && modules[i]?.moduleData?.module_size === 2)
        return false;
    }

    return true;
  }


  // Set Active Module / Handgreep
  function _setActive(e, type, object) {
    const target = e.target;

    const cardDecks = target.closest(".row").querySelectorAll(".card-deck");
    cardDecks.forEach((cardDeck) => {
      const cards = cardDeck.querySelectorAll(".card");
      cards.forEach((card) => {
        card.childNodes[0].classList.add("card-hide");
      });
    });

    if (target.classList.contains("card")) {
      target.childNodes[0].classList.remove("card-hide");
    } else {
      const card = target.closest(".card");
      card.childNodes[0].classList.remove("card-hide");
    }

    switch (type) {
      case 'Module':
        props.setActiveModule(object)
        break;
      case 'Greep':
        props.setActiveGrip(object)
        break;
      case 'Scharnier':
        // props.setActiveModule(object)
        break;
      default:
        break;
    }
  }

  function _validateInputs(type, e) {
    const errorMessage = e.target.closest(".col-lg-8").querySelector(".size-input-validation-error");
    errorMessage.innerHTML = "";
    e.target.style.border = "";

    const value = +e.target.value;
    const min = +e.target.getAttribute("min");
    const max = +e.target.getAttribute("max");

    const inputTemp = { ...inputBoxDimensions }
    if (value > max) {
      // Error Styling + Display
      e.target.style.border = "1px solid #ff0000";
      errorMessage.innerHTML = `Geef een waarde tussen ${min} en ${max}`;
      inputTemp[type] = value > max ? max : min;
    } else if (value < min) {
      e.target.style.border = "1px solid #ff0000";
      errorMessage.innerHTML = `Geef een waarde tussen ${min} en ${max}`;
      inputTemp[type] = value
    } else {
      errorMessage.innerHTML = "";
      e.target.style.border = "";
      inputTemp[type] = value
    }
    setInputBoxDimensions(inputTemp)
    props.setBoxDimensions(type, value);

    const errorElements = document.getElementsByClassName("size-input-validation-error");
    let allowNext = true;
    for (var i = 0; i < errorElements.length; i++) {
      const element = errorElements[i]
      if (element.innerHTML !== "") {
        allowNext = false;
      }
    }
    setPageControlAllowNext(allowNext)
  }

  switch (props.designstep) {
    case 1:
      panelTitle = "1. Kamer";
      panelContent = (
        <Container fluid className="overflow-scroll">
          <Row noGutters>
            <Col lg={4}>
              <p>Kast Breedte:</p>
            </Col>
            <Col lg={8}>
              <InputGroup className='mb-3 no-bottom-margin'>
                <FormControl type='number' onChange={(e) => _validateInputs("B", e)} value={inputBoxDimensions.B} min={props.validationSizes.minWidth} max={props.validationSizes.maxWidth} aria-label='Kamer Breedte' aria-describedby='basic-addon2' />
                <InputGroup.Append>
                  <InputGroup.Text id='basic-addon2'>cm</InputGroup.Text>
                </InputGroup.Append>
              </InputGroup>
              <div className='size-input-validation-error'></div>
            </Col>
          </Row>

          <Row noGutters>
            <Col lg={4}>
              <p>{props.room.room_type.includes("Plafond") ? "Kamer Hoogte:" : "Kast Hoogte"}</p>
            </Col>
            <Col lg={8}>
              <InputGroup className='mb-3 no-bottom-margin'>
                <FormControl type='number' onChange={(e) => _validateInputs("H", e)} value={inputBoxDimensions.H} min={props.validationSizes.minHeight} max={props.validationSizes.maxHeight} aria-label='Kamer Hoogte' aria-describedby='basic-addon2' />
                <InputGroup.Append>
                  <InputGroup.Text id='basic-addon2'>cm</InputGroup.Text>
                </InputGroup.Append>
              </InputGroup>
              <div className='size-input-validation-error'></div>
            </Col>
          </Row>

          <Row noGutters>
            <Col lg={4}>
              <p>Kast Diepte:</p>
            </Col>
            <Col lg={8}>
              <InputGroup className='mb-3 no-bottom-margin'>
                <FormControl type='number' onChange={(e) => _validateInputs("D", e)} value={inputBoxDimensions.D} min={props.validationSizes.minDepth} max={props.validationSizes.maxDepth} aria-label='Kamer Diepte' aria-describedby='basic-addon2' />
                <InputGroup.Append>
                  <InputGroup.Text id='basic-addon2'>cm</InputGroup.Text>
                </InputGroup.Append>
              </InputGroup>
              <div className='size-input-validation-error'></div>
            </Col>
          </Row>

          <Row noGutters>
            <Col lg={4}>
              <p>Afwerking Links:</p>
            </Col>
            <Col lg={8}>
              <InputGroup className='mb-3'>
                <FormControl type='number' onChange={(e) => _validateInputs("AL", e)} value={inputBoxDimensions.AL} min={props.validationSizes.minLeft} max={props.validationSizes.maxLeft} aria-label='Afwerking Links' aria-describedby='basic-addon2' />
                <InputGroup.Append>
                  <InputGroup.Text id='basic-addon2'>cm</InputGroup.Text>
                </InputGroup.Append>
              </InputGroup>
              <div className='size-input-validation-error'></div>
            </Col>
          </Row>

          <Row noGutters>
            <Col lg={4}>
              <p>Afwerking Rechts:</p>
            </Col>
            <Col lg={8}>
              <InputGroup className='mb-3'>
                <FormControl type='number' onChange={(e) => _validateInputs("AR", e)} value={inputBoxDimensions.AR} min={props.validationSizes.minRight} max={props.validationSizes.maxRight} aria-label='Afwerking Rechts' aria-describedby='basic-addon2' />
                <InputGroup.Append>
                  <InputGroup.Text id='basic-addon2'>cm</InputGroup.Text>
                </InputGroup.Append>
              </InputGroup>
              <div className='size-input-validation-error'></div>
            </Col>
          </Row>

          <Row noGutters>
            <Col lg={4}>
              <p>Plint Boven:</p>
            </Col>
            <Col lg={8}>
              <InputGroup className='mb-3'>
                <FormControl type='number' onChange={(e) => _validateInputs("PB", e)} value={inputBoxDimensions.PB} min={props.validationSizes.minBottom} max={props.validationSizes.maxBottom} aria-label='Plint Boven' aria-describedby='basic-addon2' />
                <InputGroup.Append>
                  <InputGroup.Text id='basic-addon2'>cm</InputGroup.Text>
                </InputGroup.Append>
              </InputGroup>
              <div className='size-input-validation-error'></div>
            </Col>
          </Row>

          <Row noGutters>
            <Col lg={4}>
              <p>Plint Onder:</p>
            </Col>
            <Col lg={8}>
              <InputGroup className='mb-3'>
                <FormControl type='number' onChange={(e) => _validateInputs("PO", e)} value={inputBoxDimensions.PO} min={props.validationSizes.minTop} max={props.validationSizes.maxTop} aria-label='Plint Onder' aria-describedby='basic-addon2' />
                <InputGroup.Append>
                  <InputGroup.Text id='basic-addon2'>cm</InputGroup.Text>
                </InputGroup.Append>
              </InputGroup>
              <div className='size-input-validation-error'></div>
            </Col>
          </Row>

          <Row>
            <Col lg={4}>
              <p>Muurkleur:</p>
            </Col>
            <Col lg={8}>
              <Form.Control type='color' onChange={e => props.setWallColor(e.target.value)} />
            </Col>
          </Row>
          {/* <Row noGutters>
            <h5>Vloertextuur</h5>
          </Row>
          <Row>
            <div className={styles["colorpicker-container"]}>
              {props.materials.map((material) => {

                //console.log(props.closetProps)
                // if (props.closetProps.innerMaterial !== null && material.material_id === props.closetProps.innerMaterial.material_id)
                //   return (
                //     <span
                //       key={material.material_id}
                //       className={styles.dot + " inside " + styles.active}
                //       style={{ backgroundImage: "url(" + material.material_texture_path + ")" }}
                //       onClick={(e) => {

                //         const dots = document.getElementsByClassName(styles.dot);

                //         for (var i = 0; i < dots.length; i++) {
                //           const dot = dots[i];
                //           if (dot.classList.contains("inside"))
                //             dot.classList.remove(styles.active)
                //         }

                //         e.target.classList.add(styles.active)

                //         props.setMaterial(material, "in");
                //       }}>
                //     </span>
                //   );
                // else
                //   return (
                //     <span
                //       key={material.material_id}
                //       className={styles.dot + " inside"}
                //       style={{ backgroundImage: "url(" + material.material_texture_path + ")" }}
                //       onClick={(e) => {

                //         const dots = document.getElementsByClassName(styles.dot);

                //         for (var i = 0; i < dots.length; i++) {
                //           const dot = dots[i];
                //           if (dot.classList.contains("inside"))
                //             dot.classList.remove(styles.active)
                //         }

                //         e.target.classList.add(styles.active)

                //         props.setMaterial(material, "in");
                //       }}>
                //     </span>
                //   );
              })}
            </div>
          </Row> */}
        </Container>
      );
      break;
    // case 1:
    //   // console.log(props.closetProps.lat);
    //   panelContent = (
    //     <Container fluid>
    //       <Row noGutters>
    //         <p>Hoe wens je de paslatten te ontvangen?</p>
    //       </Row>

    //       <Row noGutters>
    //         <Col>
    //           <FormControl type='radio' value='over' id='radio-over' name='paslat' onChange={(e) => props.handleLat(e.target.value)} checked={props.closetProps.lat == "over" ? true : false} />
    //           <FormLabel htmlFor='radio-over'>Overmaat</FormLabel>
    //         </Col>
    //       </Row>

    //       <Row noGutters>
    //         <Col>
    //           <FormControl type='radio' value='fitted' id='radio-fitted' name='paslat' onChange={(e) => props.handleLat(e.target.value)} checked={props.closetProps.lat == "fitted" ? true : false} />
    //           <FormLabel htmlFor='radio-fitted'>Op maat</FormLabel>
    //         </Col>
    //       </Row>

    //       <Row noGutters>
    //         <Col>
    //           <FormControl type='radio' value='after' id='radio-after' name='paslat' onChange={(e) => props.handleLat(e.target.value)} checked={props.closetProps.lat == "after" ? true : false} />
    //           <FormLabel htmlFor='radio-after'>Op maat nageleverd</FormLabel>
    //         </Col>
    //       </Row>
    //     </Container>
    //   );
    //   panelTitle = "2. Paslatten";
    //   break;
    case 2:
      panelContent = (
        <Container fluid className="overflow-scroll">
          <Row noGutters>
            <p>Lijst van verschillende mogelijke modules.</p>
          </Row>
          {/* NOTE: Pas de code hieronder aan (is placeholder code voor style), LET WEL OP! Als ik een bepaalde className gebruik voor style, dan gebruik die ook in het 'echte' design */}
          <Row noGutters className='row-card-container'>
            <Col>
              <Tabs defaultActiveKey='single' id='module-tab'>
                <Tab eventKey='single' title='Enkel'>
                  <CardGroup>
                    {props.modules.single.map((module, index) => {
                      //console.log("*** module 1: " + module.module_name);
                      return (
                        <OverlayTrigger key={module.module_id} placement={index >= 8 ? "top" : "bottom"} delay={{ show: 250, hide: 150 }} overlay={<Popover style={{ textAlign: "center" }}><img height='300vh' src={formatURL(module.module_model_thumbnail_path)} />{formatLines(module.module_description)}</Popover>}>
                          <Card onClick={(e) => _setActive(e, "Module", module)}>
                            <div className='card-active card-hide'>
                              <FaCheck />
                            </div>
                            <Card.Img src={formatURL(module.module_model_thumbnail_path)} />
                          </Card>
                        </OverlayTrigger>
                      )
                    })}
                  </CardGroup>
                </Tab>

                <Tab eventKey='double' title='Dubbel'>
                  <CardGroup>
                    {props.modules.double.map((module, index) => {
                      //console.log("*** module 2: " + module.module_name);
                      return (
                        <OverlayTrigger key={module.module_id} placement={index >= 8 ? "top" : "bottom"} delay={{ show: 250, hide: 150 }} overlay={<Popover style={{ textAlign: "center" }}><img height='300vh' src={formatURL(module.module_model_thumbnail_path)} />{formatLines(module.module_description)}</Popover>}>
                          <Card key={module.module_id} onClick={(e) => _setActive(e, "Module", module)}>
                            <div className='card-active card-hide'>
                              <FaCheck />
                            </div>
                            <Card.Img src={formatURL(module.module_model_thumbnail_path)} />
                          </Card>
                        </OverlayTrigger>
                      )
                    })}
                  </CardGroup>
                </Tab>
              </Tabs>
            </Col>
          </Row>
          {/* <Col>
              <Button variant="danger">Rode</Button>
            </Col>
            <Col>
              <Button variant="success">Groene</Button>
            </Col>
            <Col>
              <Button variant="primary">Blauwe</Button>
            </Col> */}
        </Container >
      );
      panelTitle = "2. Modules";
      break;
    case 3:
      panelContent = (
        <Container fluid>
          <Row noGutters>
            <p>In welke kleur wil je je kast?</p>
          </Row>
          <Row noGutters>
            <div className="colorpicker-container">
              <h5>Binnenkant</h5>
              {/*<h6 id="inner-color-hover-display">Geselecteerde kleur1: {props.closetProps.innerMaterial === null ? "Geen" : props.closetProps.innerMaterial.material_base_name}</h6>*/}
              Geselecteerde kleur:<h6 id="inner-color-hover-display">{props.closetProps.innerMaterial === null ? "Geen" : props.closetProps.innerMaterial.material_base_name}</h6>
              {props.materials.map((material) => {
                //console.log(props.closetProps)
                if (!material.material_types.includes("inner")) return

                if (props.closetProps.innerMaterial !== null && material.material_base_name === props.closetProps.innerMaterial.material_base_name)
                  return (
                    <OverlayTrigger key={material.material_base_name + "-inner"} placement="top" delay={{ show: 250, hide: 150 }} overlay={<Popover><img width='180vw' src={formatURL(material.material_texture_path)} /><p>{material.material_base_name}</p></Popover>}>
                      <span
                        key={material.material_base_name + "-inner"}
                        className="dot inside active"
                        id={material.material_base_name}
                        style={{ backgroundImage: "url(\"" + formatURL(material.material_texture_path) + "\")" }}
                        onClick={(e) => {

                          const dots = document.getElementsByClassName('dot');

                          const materialNameDisplay = document.getElementById("inner-color-hover-display");
                          materialNameDisplay.innerText = "Geselecteerde kleur: " + e.target.id;

                          for (var i = 0; i < dots.length; i++) {
                            const dot = dots[i];
                            if (dot.classList.contains("inside"))
                              dot.classList.remove('active')
                          }

                          e.target.classList.add('active')

                          setMaterial(material, "in");
                        }} />
                    </OverlayTrigger>);
                else
                  return (
                    <OverlayTrigger key={material.material_base_name + "-inner"} placement="top" delay={{ show: 250, hide: 150 }} overlay={<Popover><img height='180vw' src={formatURL(material.material_texture_path)} /><p>{material.material_base_name}</p></Popover>}>
                      <span
                        key={material.material_base_name + "-inner"}
                        className="dot inside"
                        id={material.material_base_name}
                        style={{ backgroundImage: "url(\"" + formatURL(material.material_texture_path) + "\")" }}
                        onClick={(e) => {

                          const dots = document.getElementsByClassName('dot');

                          const materialNameDisplay = document.getElementById("inner-color-hover-display")
                          materialNameDisplay.innerText = "Geselecteerde kleur: " + e.target.id

                          for (var i = 0; i < dots.length; i++) {
                            const dot = dots[i];
                            if (dot.classList.contains("inside"))
                              dot.classList.remove('active')
                          }

                          e.target.classList.add('active')

                          setMaterial(material, "in");
                        }}>
                      </span>
                    </OverlayTrigger>);
              }
              )}
            </div>
          </Row>

        </Container>
      );
      panelTitle = "3. Materialen";
      break;
    case 4:
    panelContent = (
      <Container fluid>
        <Row noGutters>
          <p>In welke kleur wil je je kast?</p>
        </Row>
        <Row noGutters>
          <div className="colorpicker-container">
            <h5>Buitenkant</h5>
            {/*<h6 id="outer-color-hover-display">Geselecteerde kleur4: {props.closetProps.outerMaterial === null ? "geen" : props.closetProps.outerMaterial.material_base_name}</h6>*/}
            Geselecteerde kleur:<h6 id="outer-color-hover-display">{props.closetProps.outerMaterial === null ? "geen" : props.closetProps.outerMaterial.material_base_name}</h6>
            {props.materials.map((material) => {
              if (!material.material_types.includes("outer")) return
              if (props.closetProps.outerMaterial !== null && material.material_base_name === props.closetProps.outerMaterial.material_base_name)
                return (
                  <OverlayTrigger key={material.material_base_name + "-outer"} placement="top" delay={{ show: 250, hide: 150 }} overlay={<Popover><img height='180vw' src={formatURL(material.material_texture_path)} /> <p>{material.material_base_name}</p></Popover>}>
                    <span
                      key={material.material_base_name + "-outer"}
                      id={material.material_base_name}
                      className="dot outside active"
                      style={{ backgroundImage: "url(\"" + formatURL(material.material_texture_path) + "\")" }}
                      onClick={(e) => {

                        const dots = document.getElementsByClassName('dot');

                        const materialNameDisplay = document.getElementById("outer-color-hover-display")
                        materialNameDisplay.innerText = "Geselecteerde kleur: " + e.target.id

                        for (var i = 0; i < dots.length; i++) {
                          const dot = dots[i];
                          if (dot.classList.contains("outside"))
                            dot.classList.remove('active')
                        }

                        e.target.classList.add('active')

                        setMaterial(material, "out");
                      }}>
                    </span>
                  </OverlayTrigger>
                );
              else
                return (
                  <OverlayTrigger key={material.material_base_name + "-outer"} placement="top" delay={{ show: 250, hide: 150 }} overlay={<Popover><img height='180vw' src={formatURL(material.material_texture_path)} /><p>{material.material_base_name}</p></Popover>}>
                    <span
                      key={material.material_base_name + "-outer"}
                      id={material.material_base_name}
                      className="dot outside"
                      style={{ backgroundImage: "url(\"" + formatURL(material.material_texture_path) + "\")" }}
                      onClick={(e) => {

                        const dots = document.getElementsByClassName('dot');

                        const materialNameDisplay = document.getElementById("outer-color-hover-display")
                        materialNameDisplay.innerText = "Geselecteerde kleur: " + e.target.id

                        for (var i = 0; i < dots.length; i++) {
                          const dot = dots[i];
                          if (dot.classList.contains("outside"))
                            dot.classList.remove('active')
                        }

                        e.target.classList.add('active')

                        setMaterial(material, "out");
                      }}>
                    </span>
                  </OverlayTrigger>
                );
            })}
          </div>
        </Row>
      </Container>
    );
    panelTitle = "3. Materialen";
    break;
  case 5:
      let hasDoors = false;
      props.slots.forEach(slot => {
        if (slot.moduleData !== undefined && slot.moduleData !== null) {
          let hd = slot.moduleData.module_has_door;
          if(hd !== undefined && hd !== null && hd !== '0') {
            hasDoors = true;
          }
          let al = slot.moduleData.module_drawer;
          if(al !== undefined && al !== null && al !== 0) {
            hasDoors = true;
          }
//          let doorIndex = slot.moduleData.module_kps_name.indexOf('DEUR');
//          let door = slot.moduleData.module_kps_name.substr(doorIndex-1, 5);
//          if (door === "D1" || door === "D2" || door === "1DEUR" || door === "2DEUR")
//            hasDoors = true
        }
      })

      panelContent = (
        <Container fluid className="overflow-scroll">
          <Row noGutters>
            <p>Je kast is bijna klaar… Het enige wat je nog hoeft te doen, is de extra's kiezen.</p>
          </Row>
          <Row noGutters className='row-card-container'>
            <Col>
              <Tabs defaultActiveKey={props.featureTypes[0].feature_type_id}>
                {props.featureTypes.map(featureType => {
                  if (hasDoors) {
                    return (
                      <Tab key={featureType.feature_type_id} eventKey={featureType.feature_type_id} title={featureType.feature_type_name}>
                        <CardGroup>
                          {props.features[featureType.feature_type_name].map(feature => {
                            if (props.closetProps.activeGrip !== null && feature.feature_id === props.closetProps.activeGrip.feature_id)
                              return (
                                <OverlayTrigger key={feature.feature_id} placement="top" delay={{ show: 250, hide: 150 }} overlay={<Popover><img width='150vw' src={formatURL(feature.feature_thumbnail_path)} /></Popover>}>
                                  <Card className="card-flex-40p" key={feature.feature_id} onClick={(e) => _setActive(e, featureType.feature_type_name, feature)}>
                                    <div className='card-active'>
                                      <FaCheck />
                                    </div>
                                    <Card.Img src={formatURL(feature.feature_thumbnail_path)} />
                                    <Card.Body>{feature.feature_name}</Card.Body>
                                  </Card>
                                </OverlayTrigger>)
                            else
                              return (
                                <OverlayTrigger key={feature.feature_id} placement="top" delay={{ show: 250, hide: 150 }} overlay={<Popover><img width='150vw' src={formatURL(feature.feature_thumbnail_path)} /></Popover>}>
                                  <Card className="card-flex-40p" key={feature.feature_id} onClick={(e) => _setActive(e, featureType.feature_type_name, feature)}>
                                    <div className='card-active card-hide'>
                                      <FaCheck />
                                    </div>
                                    <Card.Img src={formatURL(feature.feature_thumbnail_path)} />
                                    <Card.Body>{feature.feature_name}</Card.Body>
                                  </Card>
                                </OverlayTrigger>)
                          })}
                        </CardGroup>
                      </Tab>
                    )
                  } else {
                    return (
                      <Tab key={featureType.feature_type_id} eventKey={featureType.feature_type_id} title={featureType.feature_type_name}>
                        <p>Kies minstens 1 module met deuren om een {featureType.feature_type_name.toLowerCase()} te kiezen</p>
                      </Tab>
                    )
                  }

                })}
                {/* <Tab eventKey='pas' title='Paslatten'>
                  <h3>Hoe wens je de paslatten te ontvangen?</h3>
                  <CardGroup>
                    <Card onClick={(e) => _setActive(e)}>
                      <div className='card-active card-hide'>
                        <FaCheck />
                      </div>
                      <Card.Img src='https://via.placeholder.com/150' />
                    </Card>
                    <Card onClick={(e) => _setActive(e)}>
                      <div className='card-active card-hide'>
                        <FaCheck />
                      </div>
                      <Card.Img src='https://via.placeholder.com/150' />
                    </Card>
                  </CardGroup>
                </Tab> */}
              </Tabs>
            </Col>
          </Row>
        </Container >
      );
      panelTitle = "4. Extra's";
      break;
    case 6:
      bestellenKnop = true;

      panelContent = (
        <Container fluid className="overflow-scroll">
          <Row noGutters>
            <p>De kast is ontworpen, bestellen maar!</p>
          </Row>
          <div className="summary">
            <h6>Kamer</h6>
            <p>Breedte: {props.boxDimensions.B}cm</p>
            <p>Hoogte: {props.boxDimensions.H}cm</p>
            <p>Diepte (Kast): {props.boxDimensions.D}cm</p>
            <p>Afwerking (L): {props.boxDimensions.AL}cm</p>
            <p>Afwerking (R): {props.boxDimensions.AR}cm</p>
            <p>Plint (B): {props.boxDimensions.PB}cm</p>
            <p>Plint (O): {props.boxDimensions.PO}cm</p>

            <br />

            <h6>Modules</h6>
            <p>Enkel: {_hasNoSingleModules() ? 'Geen' : ''}</p>
            <CardGroup>
              {props.slots.map((module, index) => {
                return module?.moduleData == null || module?.moduleData?.module_size != 1 ? null : <Card className="card-flex-10p" key={index}>
                  <Card.Img src={formatURL(module?.moduleData?.module_model_thumbnail_path)} title={module?.moduleData?.module_name} alt={module?.moduleData?.module_name} />
                </Card>
              })}
            </CardGroup>

            <p>Dubbel: {_hasNoDoubleModules() ? 'Geen' : ''}</p>
            <CardGroup>
              {props.slots.map((module, index) => {
                return module?.moduleData == null || module?.moduleData?.module_size != 2 ? null : <Card key={index}>
                  <Card.Img src={formatURL(module?.moduleData?.module_model_thumbnail_path)} title={module?.moduleData?.module_name} alt={module?.moduleData?.module_name} />
                </Card>
              })}
            </CardGroup>

            <br />

            <h6>Materialen</h6>
            <p>Binnenkant: {props.closetProps.innerMaterial?.material_base_name ?? "Geen"}</p>
            <p>Buitenkant: {props.closetProps.outerMaterial?.material_base_name ?? "Geen"}</p>

            <br />

            <h6>Handgreep</h6>
            <CardGroup>
              <Card className="card-flex-40p">
                <Card.Img src={formatURL(props.activeGrip?.feature_thumbnail_path)} title={props.activeGrip?.feature_name + " (" + props.activeGrip?.feature_type_name + ")"} alt={props.activeGrip?.feature_name + " (" + props.activeGrip?.feature_type_name + ")"} />
                <Card.Body>{props.activeGrip?.feature_name}</Card.Body>
              </Card>
            </CardGroup>
            {/*<p></p>
            {orderErrors["order_error"] ? <Alert variant='danger'>{formatLines(orderErrors["order_error"])}</Alert> : <Alert></Alert>}*/}
          </div>

          <Modal show={showErrors} onHide={() => handleErrors(false)}>
            <Modal.Header closeButton>
              <Modal.Title>Fouten</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {formatLines(orderErrors["order_error"])}
            </Modal.Body>
          </Modal>

          <Modal show={showOrderPopup} onHide={() => handleOrderPopup(false)}>
            <Modal.Header closeButton>
              <Modal.Title>Bestelgegevens</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form method='POST' encType='multipart/form-data' onSubmit={props.submitOrder}>
                <Form.Group>
                  {/*<Form.Label>Naam <CustomerNameTooltip /></Form.Label>*/}
                  <Form.Control type='text' placeholder='Naam' name='customer_name' />
                  <span className={props.formErrors["customer_name"] ? "form-error" : "form-error-hidden"}>{props.formErrors["customer_name"]}</span>
                </Form.Group>
                <Form.Group>
                  {/*<Form.Label>E-mailadres <CustomerEmailTooltip /></Form.Label>*/}
                  <Form.Control type='email' placeholder='E-mailadres' name='customer_email' />
                  <span className={props.formErrors["customer_email"] ? "form-error" : "form-error-hidden"}>{props.formErrors["customer_email"]}</span>
                </Form.Group>
                <Form.Group>
                  {/*<Form.Label>BTW-nummer (optioneel) <CustomerBTWTooltip /></Form.Label>*/}
                  <Form.Control type='text' placeholder='BTW-nummer (optioneel)' name='customer_btw' />
                  <span className={props.formErrors["customer_btw"] ? "form-error" : "form-error-hidden"}>{props.formErrors["customer_btw"]}</span>
                </Form.Group>

                {/* Start Bezorg Adres */}
                <h5>Bezorgadres</h5>
                <Form.Group>
                  {/*<Form.Label>Straatnaam <CustomerStreetTooltip /></Form.Label>*/}
                  <Form.Control type='text' placeholder='Straatnaam' name='customer_delivery_street' />
                  <span className={props.formErrors['customer_delivery_street'] ? 'form-error' : 'form-error-hidden'}>{props.formErrors['customer_delivery_street']}</span>
                </Form.Group>
                <Form.Group>
                  {/*<Form.Label>Huisnummer & Bus <CustomerNumberTooltip /></Form.Label>*/}
                  <Form.Control type='text' placeholder='Huisnummer & Bus' name='customer_delivery_number' />
                  <span className={props.formErrors['customer_delivery_number'] ? 'form-error' : 'form-error-hidden'}>{props.formErrors['customer_delivery_number']}</span>
                </Form.Group>
                <Row>
                  <Col>
                    <Form.Group>
                      {/*<Form.Label>Postcode <CustomerZipTooltip /></Form.Label>*/}
                      <Form.Control type='text' placeholder='Postcode' name='customer_delivery_zip' />
                      <span className={props.formErrors['customer_delivery_zip'] ? 'form-error' : 'form-error-hidden'}>{props.formErrors['customer_delivery_zip']}</span>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group>
                      {/*<Form.Label>Gemeente <CustomerCityTooltip /></Form.Label>*/}
                      <Form.Control type='text' placeholder='Gemeente' name='customer_delivery_city' />
                      <span className={props.formErrors['customer_delivery_city'] ? 'form-error' : 'form-error-hidden'}>{props.formErrors['customer_delivery_city']}</span>
                    </Form.Group>
                  </Col>
                </Row>

                {/* Start Factuur Adres */}
                <h5>Factuuradres</h5>
                <Form.Group>
                  <Form.Check type="checkbox" id="invoice_address_checkbox" name="customer_invoice_equals_delivery" label="Hetzelfde als bezorgadres" />
                </Form.Group>

                <div className={props.hideInvoiceAddress ? "card-hide" : ""}>
                  <Form.Group>
                    {/*<Form.Label>Straatnaam <CustomerStreetTooltip /></Form.Label>*/}
                    <Form.Control type='text' placeholder='Straatnaam' name='customer_invoice_street' />
                    <span className={props.formErrors['customer_invoice_street'] ? 'form-error' : 'form-error-hidden'}>{props.formErrors['customer_invoice_street']}</span>
                  </Form.Group>
                  <Form.Group>
                    {/*<Form.Label>Huisnummer & Bus <CustomerNumberTooltip /></Form.Label>*/}
                    <Form.Control type='text' placeholder='Huisnummer & Bus' name='customer_invoice_number' />
                    <span className={props.formErrors['customer_invoice_number'] ? 'form-error' : 'form-error-hidden'}>{props.formErrors['customer_invoice_number']}</span>
                  </Form.Group>
                  <Row>
                    <Col>
                      <Form.Group>
                        {/*<Form.Label>Postcode <CustomerZipTooltip /></Form.Label>*/}
                        <Form.Control type='text' placeholder='Postcode' name='customer_invoice_zip' />
                        <span className={props.formErrors['customer_invoice_zip'] ? 'form-error' : 'form-error-hidden'}>{props.formErrors['customer_invoice_zip']}</span>
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group>
                        {/*<Form.Label>Gemeente <CustomerCityTooltip /></Form.Label>*/}
                        <Form.Control type='text' placeholder='Gemeente' name='customer_invoice_city' />
                        <span className={props.formErrors['customer_invoice_city'] ? 'form-error' : 'form-error-hidden'}>{props.formErrors['customer_invoice_city']}</span>
                      </Form.Group>
                    </Col>
                  </Row>
                </div>
                
                <hr/>
                  <Form.Control type='text' placeholder="Actiecode" name='discount_code' />
                <hr/>

                <Form.Group>
                  <Form.Check type="checkbox" id="algv_checkbox" label="Algemene voorwaarden gelezen" onChange={toggleButtonOrder}/>
                </Form.Group>

                {changeBestellen()}
                <Button variant='primary' type='submit' id="btnOrder" disabled={bestellenKnop}>Bestellen</Button>
                <p>
                  <Form.Label id="mylabel" hidden="hidden">De bestelling is geplaatst, u wordt doorverwezen naar de betaalsite. Even wachten aub...</Form.Label>
                </p>
                <p></p>
                {props.formErrors["order_error"] ? <Alert variant='danger'>{props.formErrors["order_error"]}</Alert> : null}
              </Form>
            </Modal.Body>
          </Modal>
        </Container>
      );
      panelTitle = "5. Bestelling plaatsen";
      break;
    default:
  }

  return (
    <div className='side-panel'>
      <Row style={{ justifyContent: "flex-end", paddingRight: "15px" }}>
        <DesignStepToolTip helps={props.helps} designstep={props.designstep} />
      </Row>
      <Row className='side-panel-title-row'>
        <Col lg={6}>
          <h5>{panelTitle}</h5>
        </Col>
        {
          props.designstep > 1 ? <Col lg={6}>
            <span id='totalProjectPrice'>Totaal: € {props.totalPrice}</span>
          </Col> :
            null
        }

      </Row>

      {panelContent}
      {pageControl}
    </div>
  );
}

export default SidePanel;
